/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc
 */
import * as References from './CollectionsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc#getCollectionBySlug
 */
export const GET_COLLECTION_BY_SLUG_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_discovery_studio_rpc_CollectionsRpc_getCollectionBySlug';
export const GET_COLLECTION_BY_SLUG_QUERY: RegisteredQuery<
  'result',
  References.GetCollectionBySlugRequestType,
  References.GetCollectionBySlugResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_COLLECTION_BY_SLUG_QUERY_FIELD_NAME,
  args: ['slug', 'offset', 'limit', 'filter', 'search', 'sorts'],
  fetcher(
    request: References.GetCollectionBySlugRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetCollectionBySlugResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getCollectionBySlugRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc#getAllCollections
 */
export const GET_ALL_COLLECTIONS_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_discovery_studio_rpc_CollectionsRpc_getAllCollections';
export const GET_ALL_COLLECTIONS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetAllCollectionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_ALL_COLLECTIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetAllCollectionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getAllCollectionsRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});
